import { AccessRole } from 'api/types'

import { AuthLocale } from './AuthShell'
import { roleLabel } from './roleLabels'

export const RoleBadge = ({ role, locale }: { role: AccessRole; locale: AuthLocale }) => (
  <span className="role-badge">{roleLabel(role, locale)}</span>
)
